import cx from 'classnames'
import Styles from './BottomMessage.module.scss'
import { Layer } from 'types'
import { MergeLayerButton } from './MergeLayerButton'

interface Props {
  layer: Layer
}

export const LayerMergeCompleteMessage = ({ layer }: Props) => (
  <div className={cx(Styles.messageContainer, Styles.finished)}>
    <div className={Styles.emoji}>✨</div>
    <div className={Styles.message}>
      <div>You are all done!</div>
      <span>You can now merge the layer</span>
    </div>
    <MergeLayerButton layer={layer} />
  </div>
)
